/* tp-product.js — native-product controller + AJAX cart drawer for the TickProtect draft theme.
   Shrine's core product/cart JS (product-form / variant-selects / quantity-input / cart-drawer)
   was gutted from this theme, so this restores the needed behaviour with no framework deps:
     - Variant selection -> updates the hidden `id` input (so the SELECTED variant is added)
     - Option labels + sold-out state; quantity +/- buttons
     - A slide-out cart drawer that opens on Add-to-cart and on the header cart icon
   It does NOT touch price (the displayed price is Shopify-Markets currency-converted). */
(function () {
  'use strict';
  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function cq(s){ return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/(["\\\]\[])/g, '\\$1'); }

  /* ============================ VARIANT + QUANTITY ============================ */
  ready(function () {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var firstCtrl = vs.querySelector('input[name], select[name]');
    var formId = firstCtrl && firstCtrl.getAttribute('form');
    var form = (formId && document.getElementById(formId)) ||
               document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('button[name="add"], [type="submit"][name="add"], .product-form__submit');
    var atcText = atc && atc.querySelector('.main-atc__label__text, .button__label');

    var qWrap = document.querySelector('quantity-input') || form;
    var qInput = qWrap.querySelector('input[name="quantity"], .quantity__input') || form.querySelector('input[name="quantity"]');
    var qMinus = qWrap.querySelector('button[name="minus"], .quantity__button--minus');
    var qPlus  = qWrap.querySelector('button[name="plus"], .quantity__button--plus');
    function qval(){ var n = parseInt(qInput && qInput.value, 10); return (isNaN(n) || n < 1) ? 1 : n; }
    /* Shrine's native <quantity-input> element already handles +/- clicks; binding here too made every click count twice (qty jumped 1->3->5). Only wire when the native element is absent (gutted themes). */
    var nativeQty = !!(window.customElements && customElements.get('quantity-input'));
    if (qInput && qMinus && !nativeQty) qMinus.addEventListener('click', function (e){ e.preventDefault(); qInput.value = Math.max(1, qval() - 1); qInput.dispatchEvent(new Event('change', { bubbles: true })); });
    if (qInput && qPlus && !nativeQty)  qPlus.addEventListener('click',  function (e){ e.preventDefault(); qInput.value = qval() + 1; qInput.dispatchEvent(new Event('change', { bubbles: true })); });

    var url = vs.getAttribute('data-url') || '';
    if (!url) return;
    fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r){ return r.json(); })
      .then(function (product){
        var optNames = (product.options || []).map(function (o){ return (typeof o === 'string') ? o : o.name; });
        var labelSpans = [].slice.call(vs.querySelectorAll('[id^="custom-label-"]'));
        function selectedVals(){
          return optNames.map(function (name){
            var nm = cq(name);
            var sel = vs.querySelector('select[name="' + nm + '"], select[name="options[' + nm + ']"]');
            if (sel) return sel.value;
            var radios = [].slice.call(vs.querySelectorAll('input[type="radio"][name="' + nm + '"], input[type="radio"][name="options[' + nm + ']"]'));
            var checked = radios.filter(function (r){ return r.checked; })[0];
            return checked ? checked.value : (radios[0] ? radios[0].value : null);
          });
        }
        function findVariant(vals){
          return (product.variants || []).filter(function (v){
            for (var i = 0; i < optNames.length; i++){ if (v.options[i] !== vals[i]) return false; }
            return true;
          })[0];
        }
        function apply(){
          var vals = selectedVals();
          labelSpans.forEach(function (sp, i){ if (optNames[i] != null && vals[i] != null) sp.textContent = optNames[i] + ' - ' + vals[i]; });
          var v = findVariant(vals);
          if (!v) return;
          var idInputs = [].slice.call(document.querySelectorAll('input[name="id"]'));
          if (!idInputs.length && idInput) idInputs = [idInput];
          idInputs.forEach(function (inp){ inp.value = v.id; });
          if (atc){
            if (v.available === false){ atc.setAttribute('disabled', 'disabled'); atc.classList.add('disabled'); if (atcText) atcText.textContent = 'Sold out'; }
            else { atc.removeAttribute('disabled'); atc.classList.remove('disabled'); if (atcText) atcText.textContent = 'Add to cart'; }
          }
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
        }
        [].slice.call(vs.querySelectorAll('input[type="radio"], select')).forEach(function (el){ el.addEventListener('change', apply); });
        apply();
      })
      .catch(function () {});
  });

  /* ============================ CART DRAWER ============================ */
  ready(function () {
    var drawer = document.getElementById('tpd');
    var overlay = document.getElementById('tpd-overlay');
    if (!drawer || !overlay) return;
    // The drawer markup lives inside a section wrapper that has a transform/containment,
    // which traps position:fixed (anchors it to the section box, not the viewport).
    // Relocate both to be direct children of <body> so fixed positioning works.
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    var body = drawer.querySelector('.tpd__body');
    var subEl = drawer.querySelector('.tpd__sub');
    var closeBtn = drawer.querySelector('.tpd__close');

    function money(cents, cur){
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format((cents || 0) / 100); }
      catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
    }
    function setCount(n){ var c = document.querySelector('.tp-cart__count'); if (c) c.textContent = n; }
    function open(){ overlay.hidden = false; requestAnimationFrame(function(){ drawer.classList.add('tpd--open'); overlay.classList.add('tpd-overlay--open'); }); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close(){ drawer.classList.remove('tpd--open'); overlay.classList.remove('tpd-overlay--open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; setTimeout(function(){ overlay.hidden = true; }, 320); }

    function render(cart){
      setCount(cart.item_count);
      var sub = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
      if (subEl) subEl.textContent = money(sub, cart.currency);
      if (!cart.items || !cart.items.length){ body.innerHTML = '<p class="tpd__empty">Your cart is empty.</p>'; return; }
      body.innerHTML = cart.items.map(function (it){
        var img = it.image ? it.image.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_140x$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="tpd__variant">' + it.variant_title + '</div>' : '';
        return '<div class="tpd__item" data-key="' + it.key + '">' +
          (img ? '<img class="tpd__img" src="' + img + '" alt="" loading="lazy">' : '<div class="tpd__img"></div>') +
          '<div class="tpd__meta"><div class="tpd__title">' + it.product_title + '</div>' + variant +
          '<div class="tpd__qty"><button type="button" class="tpd__minus" aria-label="Decrease">&minus;</button><span class="tpd__q">' + it.quantity + '</span><button type="button" class="tpd__plus" aria-label="Increase">+</button><button type="button" class="tpd__remove">Remove</button></div></div>' +
          '<div class="tpd__price">' + money(it.final_line_price, cart.currency) + '</div></div>';
      }).join('');
    }
    function refresh(openAfter){
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r){ return r.json(); })
        .then(function (c){ render(c); if (openAfter) open(); return c; });
    }
    function change(key, qty){
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r){ return r.json(); }).then(function (c){ render(c); });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e){ if (e.key === 'Escape') close(); });
    body.addEventListener('click', function (e){
      var item = e.target.closest('.tpd__item'); if (!item) return;
      var key = item.getAttribute('data-key');
      var q = parseInt(item.querySelector('.tpd__q').textContent, 10) || 1;
      if (e.target.closest('.tpd__plus')) change(key, q + 1);
      else if (e.target.closest('.tpd__minus')) change(key, Math.max(0, q - 1));
      else if (e.target.closest('.tpd__remove')) change(key, 0);
    });

    // header cart icon -> open drawer instead of navigating to /cart
    var cartLink = document.querySelector('.tp-cart');
    if (cartLink) cartLink.addEventListener('click', function (e){ e.preventDefault(); refresh(true); });

    // Add-to-cart on every product form -> AJAX add -> open drawer (fallback to native submit on error)
    [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).forEach(function (form){
      form.addEventListener('submit', function (e){
        e.preventDefault();
        var btn = form.querySelector('button[name="add"], [type="submit"][name="add"], .product-form__submit');
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (){ if (btn) btn.removeAttribute('aria-busy'); return refresh(true); })
          .catch(function (){ form.submit(); });
      });
    });
  });
})();
